import PropertyType from "../../shared/PropertyType";
import { CLIENTINTENT } from "../../../../shared/reduxRoutes/tdpDetailsRoutes";
import { tdpDetails } from "../../../../shared/HOCs/withRedux";

export default tdpDetails({
  WrappedComponent: PropertyType,
  states: CLIENTINTENT,
  aliases: "propertyType",
});
